document.addEventListener("DOMContentLoaded", function () {
  const currentLang = window.locale

  $('#language-picker a').on('click', function (e) {
    axios.post(`/language`, {lang: $(e.target).data('lang')}).then((response) => {
      location.reload();
    })
  })
})